import React from 'react';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';

const useStyles = createUseStyles({
    td: {
        padding: 0,
        backgroundColor: 'inherit',
        overflow: 'hidden',
    },
    tdFocusable: {
        cursor: 'text',
        '&:focus-within': {
            outline: `1px solid ${colors.blueLink}`,
            outlineOffset: -1,
        },
    },
    tdInvalid: {
        cursor: 'text',
        outline: `1px solid ${colors.redOne}`,
        outlineOffset: -1,
        backgroundColor: colors.redFive,
        '&:focus-within': {
            outline: `1px solid ${colors.redOne}`,
            outlineOffset: -1,
        },
    },
    content: {
        overflowX: 'hidden',
        overflowY: 'visible',
        padding: '8px 12px',
        width: '100%',
    },
});

interface DynamicGridCellProps {
    onMouseEnter?: React.MouseEventHandler<HTMLTableCellElement>;
    onMouseLeave?: React.MouseEventHandler<HTMLTableCellElement>;
    onClick?: React.MouseEventHandler<HTMLTableCellElement>;
    children: React.ReactNode;
    className?: string;
    readOnly?: boolean;
    invalid?: boolean;
}

export function DynamicGridCell({
    className,
    children,
    onMouseEnter,
    onMouseLeave,
    onClick,
    readOnly = false,
    invalid = false,
}: DynamicGridCellProps) {
    const classes = useStyles();

    const tdClassName = `${classes.td} ${invalid ? classes.tdInvalid : !readOnly ? classes.tdFocusable : ''} ${
        className ?? ''
    }`;

    return (
        <td
            className={tdClassName}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={!readOnly ? onClick : undefined}
        >
            <div className={classes.content}>{children}</div>
        </td>
    );
}
